import { useEffect } from 'react';

import type { MutableRefObject } from 'react';

interface UseAppointmentCardInfoTooltipEffectsParams {
  resetTimerRef: MutableRefObject<number | undefined>;
}

export const useAppointmentCardInfoTooltipEffects = ({
  resetTimerRef,
}: UseAppointmentCardInfoTooltipEffectsParams) => {
  // Тултип может закрыться раньше, чем вернётся иконка копирования, —
  // гасим таймер, чтобы не обновлять состояние размонтированного хука.
  useEffect(() => {
    const resetTimer = resetTimerRef;

    return () => window.clearTimeout(resetTimer.current);
  }, [resetTimerRef]);
};
